import { supabase } from '../../supabase/client';

export interface RecentPurchase {
    masked_name: string;
    city_short: string;
    minutes_ago: number;
}

const cache = new Map<string, { at: number; rows: RecentPurchase[] }>();
const TTL_MS = 60000;

export async function fetchRecentPurchases(formId: string): Promise<RecentPurchase[]> {
    if (!formId) return [];
    const hit = cache.get(formId);
    if (hit && Date.now() - hit.at < TTL_MS) return hit.rows;
    try {
        const { data, error } = await supabase.rpc('get_recent_public_purchases', { p_form_id: formId, p_limit: 10 });
        if (error || !Array.isArray(data)) return [];
        const rows = (data as RecentPurchase[]).filter((r) => r && r.masked_name && r.city_short);
        cache.set(formId, { at: Date.now(), rows });
        return rows;
    } catch {
        return [];
    }
}

export function timeAgoId(minutes: number): string {
    if (minutes < 1) return 'baru saja';
    if (minutes < 60) return `${minutes} menit lalu`;
    const h = Math.floor(minutes / 60);
    if (h < 24) return `${h} jam lalu`;
    return `${Math.floor(h / 24)} hari lalu`;
}
